import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

export const withRouter = (Component) => {
  const Wrapper = (props) => {
    const history = useNavigate();
    return <Component history={history} {...props} />;
  };
  return Wrapper;
};

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  const reload = location.pathname;
  const userAgent = navigator.userAgent;
  const element = document.querySelector("body");


  useEffect(() => {
    if (userAgent.includes("Firefox")) {
      element.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    } else if (!location.hash) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    }

    // Scroll to hash target with offset
    if (location.hash) {
      setTimeout(() => {
        const id = location.hash.replace("#", "");
        const target = document.getElementById(id);
        if (target) {
          // const yOffset = -100;
          const header = document.querySelector("top_navbar");
          const yOffset = -(header?.offsetHeight || 100);
          const y =
            target.getBoundingClientRect().top + window.pageYOffset + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }
      }, 100); // Delay to wait for DOM to render
    }
  }, [reload, location.hash]);

  return children || null;
};

export default withRouter(ScrollToTop);
